module.exports = __webpack_public_path__ + "img/HTCC-AM02.f3957f0b.jpg";